import { useQuery } from '@tanstack/react-query';

import type { ExtranetExperience } from 'app/typings/packages';
import { apiRequest } from 'app/utils/request/api';

const path = '/extranet/:hotelId/experiences' as const;

export type HotelExtranetExperiences = {
  experiences: ExtranetExperience[];
};

export function useExperiencesByHotelId(hotelId: number) {
  return useQuery<HotelExtranetExperiences>({
    queryKey: [path, { hotelId }],
    queryFn: () =>
      apiRequest({
        path: path,
        params: { hotelId: hotelId.toString() },
      }),
    staleTime: Infinity,
  });
}
